import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class CustomerUser extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/user`)
  }

  changePassword(userId, password, showProgress) {
    return this._request({
      action: `${userId}/password`,
      body: { password },
      method: 'PATCH',
      showProgress
    })
  }

  unblock(userId, showProgress) {
    return this._request({
      action: `${userId}/unlock`,
      method: 'PATCH',
      showProgress
    })
  }

  confirmMobile(userId, showProgress) {
    return this._request({
      action: `${userId}/mobile/confirm`,
      method: 'PATCH',
      showProgress
    })
  }

  brief(userId, showProgress) {
    return this._request({
      action: `${userId}/brief`,
      method: 'GET',
      showProgress
    })
  }

  updateRoles(userId, model, showProgress) {
    return this._request({
      action: `${userId}/role`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateLicensePermission(userId, model, showProgress) {
    return this._request({
      action: `${userId}/licensePermission`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateLimit(userId, model, showProgress) {
    return this._request({
      action: `${userId}/limit`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateLicenseLimit(userId, model, showProgress) {
    return this._request({
      action: `${userId}/licenseLimit`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateGeneralLimit(model, showProgress) {
    return this._request({
      action: 'all/limit',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  getGeneralLimits(showProgress) {
    return this._request({
      action: 'all/limit',
      method: 'GET',
      showProgress
    })
  }

  enableTester(userId, showProgress) {
    return this._request({
      action: `${userId}/tester/set`,
      method: 'PATCH',
      showProgress
    })
  }

  disableTester(userId, showProgress) {
    return this._request({
      action: `${userId}/tester/unset`,
      method: 'PATCH',
      showProgress
    })
  }

  enableTwoFactorAuth(userId, showProgress) {
    return this._request({
      action: `${userId}/twoFactor/set`,
      method: 'PATCH',
      showProgress
    })
  }

  disableTwoFactorAuth(userId, showProgress) {
    return this._request({
      action: `${userId}/twoFactor/unset`,
      method: 'PATCH',
      showProgress
    })
  }

  suspend(model, showProgress) {
    return this._request({
      action: `${model.id}/suspend`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  unsuspend(userId, showProgress) {
    return this._request({
      action: `${userId}/unsuspend`,
      method: 'PATCH',
      showProgress
    })
  }

  delete(userId, model, showProgress) {
    return this._request({
      action: userId,
      method: 'DELETE',
      body: model,
      showProgress
    })
  }

  getLegalInformation(userId, showProgress) {
    return this._request({
      action: `${userId}/legal`,
      method: 'GET',
      showProgress
    })
  }

  updateLegal(userId, model, showProgress) {
    return this._request({
      action: `${userId}/legal`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }
}
